import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { getClientDomainPrefix } from './data/DynamoConnector';
import { ToastContainer } from 'react-toastify';

window.signOutRedirect = () => {
    const clientId = '63des98g40o9uj0ql7kbstqgp8';
    const logoutUri = getClientDomainPrefix();
    const cognitoDomain = 'https://commandersalt.auth.us-east-1.amazoncognito.com';
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};

window.cognitoAuthConfig = {
    authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_erfnC6lSF',
    client_id: '63des98g40o9uj0ql7kbstqgp8',
    client_secret: '1946eh194kqhs2aqie8bab0v3b3aeo1thqiij932704m1ta84ku',
    redirect_uri: getClientDomainPrefix(),
    response_type: 'code',
    scope: 'email openid profile',
    // Strip ?code=&state= from the URL after the token exchange without a
    // full page load — a hard redirect here raced react-oidc-context's
    // state update and left the app rendering logged-out until reload.
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
    userStore: new WebStorageStateStore({
        store: localStorage,
    }),
    automaticSilentRenew: true,
};

createRoot(document.getElementById('root')).render(
    <>
        <AuthProvider {...window.cognitoAuthConfig}>
            <App />
        </AuthProvider>
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            style={{ zIndex: 200000 }}
        />
    </>
);
